// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/bg-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  text-decoration: none;
}

body {
  font-size: 0.875rem;
  background-color: #393939;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
}

.selector,
img {
  -webkit-user-drag: none;
  user-drag: none;
  -webkit-user-select: none;
  user-select: none;
}

.PanelCard {
  background-color: #373737;
  padding: 40px 50px !important;
  border-radius: 10px;
}

.btn-animation {
  transition: all 0.3s ease;
}

.btn-main {
  background-color: #f7d091;
  border-radius: 40px;
  color: #000000;
  font-size: 15px;
  padding: 6px 12px;
}

.btn-main:hover {
  transform: translateY(-5px);
  background-color: #f7d091;
  border-radius: 40px;
  color: #000000;
  font-size: 15px;
}

.btn-download {
  transition: all 0.3s ease;
}

.btn-download:hover {
  transform: translateY(-5px);
}

/* FORM CONTROL */
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 10px;
  border: solid 2px #7a7a7a;
  background-color: transparent;
}

.form-control:active {
  border: solid 2px #7f6994;
  outline: none;
}

.form-control:focus {
  border: solid 2px #7f6994;
  box-shadow: 0 0 0 0.25rem rgba(13, 109, 253, 0);
}

/* END FORM CONTROL */

/* FORM SELECT */
.form-select {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 10px;
  border: solid 2px #7a7a7a;
  background-color: transparent;
  height: 45px;
}

.form-select:active {
  border: solid 2px #7f6994;
  outline: none;
}

.form-select:focus {
  border: solid 2px #7f6994;
  box-shadow: 0 0 0 0.25rem rgba(13, 109, 253, 0);
}

/* END FORM SELECT */

/* FORM FLOATING */
.form-floating>label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
  font-size: 1rem;
  padding: 0.365rem 0.75rem;
  align-content: center;
}

.form-floating>.form-control:focus~label::after,
.form-floating>.form-control:not(:placeholder-shown)~label::after,
.form-floating>.form-control-plaintext~label::after,
.form-floating>.form-select~label::after {
  position: absolute;
  inset: 0rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}

.form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-control-plaintext~label,
.form-floating>.form-select~label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  height: 45%;
  padding: 0rem 0.5rem;
  top: -5px;
  color: #7f6994;
  font-weight: 500;
  font-size: 1.1rem;
  background-color: #ffff;
  left: 15px;
}

.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown),
.form-floating>.form-control-plaintext:focus,
.form-floating>.form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext,
.form-floating>.form-select {
  padding: 0.365rem 0.75rem;
  height: 45px;
  min-height: 45px;
}

/* END FORM FLOATING */

/* FORM CHECK INPUT */
.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1.5em;
  height: 1.5em;
  margin-top: 0em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: solid 2px #7f6994;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.form-check-input[type="checkbox"] {
  border-radius: 0.25em;
}

.form-check-input[type="radio"] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
  border: none;
}

.form-check-input:focus {
  border-color: #3d3049;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 109, 253, 0);
}

.form-check-input:checked {
  background-color: #7f6994;
  border-color: #4f3366;
}

.form-check-input:checked[type="checkbox"] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check-input:checked[type="radio"] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input[type="checkbox"]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
  cursor: default;
  opacity: 0.5;
}

/* END FORM CHECK INPUT */

.profile-container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.profile-img {
  width: 25%;
  padding: 5px 5px;
  border: 3px solid #ceae7b;
  border-radius: 100%;
}

.profile-verified {
  width: 1.5rem;
}

@media (max-width: 575.98px) {
  .profile-img {
    width: 50%;
    padding: 5px 5px;
    border: 3px solid #ceae7b;
    border-radius: 100%;
  }

  .btn-download {
    width: 50%;
  }
}

@media (max-width: 768px) {
  .btn-download {
    width: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/ShareProfileCSS.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yDAA2C;EAC3C,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;EAEf,yBAAyB;EAEzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAG3B,gBAAgB;EAChB,4BAA4B;EAC5B,wEAAwE;EACxE,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,qBAAqB;;AAErB,gBAAgB;AAChB;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAG3B,gBAAgB;EAChB,4BAA4B;EAC5B,wEAAwE;EACxE,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,oBAAoB;;AAEpB,kBAAkB;AAClB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;EAChD,qBAAqB;EACrB,gEAAgE;EAChE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,WAAW;EACX,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;;;;EAIE,2CAA2C;EAC3C,8DAA8D;EAC9D,WAAW;EACX,oBAAoB;EACpB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;;;EAIE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sBAAsB;;AAEtB,qBAAqB;AACrB;EACE,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EAGnB,gBAAgB;EAChB,yCAAyC;EACzC,+CAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EAEjC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iEAAuP;AACzP;;AAEA;EACE,iEAA+J;AACjK;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iEAAiP;AACnP;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n}\n\nbody {\n  font-size: 0.875rem;\n  background-color: #393939;\n  background-image: url(\"../assets/bg-1.png\");\n  background-position: center;\n  background-size: cover;\n}\n\n.selector,\nimg {\n  -webkit-user-drag: none;\n  user-drag: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.PanelCard {\n  background-color: #373737;\n  padding: 40px 50px !important;\n  border-radius: 10px;\n}\n\n.btn-animation {\n  transition: all 0.3s ease;\n}\n\n.btn-main {\n  background-color: #f7d091;\n  border-radius: 40px;\n  color: #000000;\n  font-size: 15px;\n  padding: 6px 12px;\n}\n\n.btn-main:hover {\n  transform: translateY(-5px);\n  background-color: #f7d091;\n  border-radius: 40px;\n  color: #000000;\n  font-size: 15px;\n}\n\n.btn-download {\n  transition: all 0.3s ease;\n}\n\n.btn-download:hover {\n  transform: translateY(-5px);\n}\n\n/* FORM CONTROL */\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-clip: padding-box;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  border-radius: 10px;\n  border: solid 2px #7a7a7a;\n  background-color: transparent;\n}\n\n.form-control:active {\n  border: solid 2px #7f6994;\n  outline: none;\n}\n\n.form-control:focus {\n  border: solid 2px #7f6994;\n  box-shadow: 0 0 0 0.25rem rgba(13, 109, 253, 0);\n}\n\n/* END FORM CONTROL */\n\n/* FORM SELECT */\n.form-select {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-clip: padding-box;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  border-radius: 10px;\n  border: solid 2px #7a7a7a;\n  background-color: transparent;\n  height: 45px;\n}\n\n.form-select:active {\n  border: solid 2px #7f6994;\n  outline: none;\n}\n\n.form-select:focus {\n  border: solid 2px #7f6994;\n  box-shadow: 0 0 0 0.25rem rgba(13, 109, 253, 0);\n}\n\n/* END FORM SELECT */\n\n/* FORM FLOATING */\n.form-floating>label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n  font-size: 1rem;\n  padding: 0.365rem 0.75rem;\n  align-content: center;\n}\n\n.form-floating>.form-control:focus~label::after,\n.form-floating>.form-control:not(:placeholder-shown)~label::after,\n.form-floating>.form-control-plaintext~label::after,\n.form-floating>.form-select~label::after {\n  position: absolute;\n  inset: 0rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n\n.form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-control-plaintext~label,\n.form-floating>.form-select~label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  height: 45%;\n  padding: 0rem 0.5rem;\n  top: -5px;\n  color: #7f6994;\n  font-weight: 500;\n  font-size: 1.1rem;\n  background-color: #ffff;\n  left: 15px;\n}\n\n.form-floating>.form-control:focus,\n.form-floating>.form-control:not(:placeholder-shown),\n.form-floating>.form-control-plaintext:focus,\n.form-floating>.form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.form-floating>.form-control,\n.form-floating>.form-control-plaintext,\n.form-floating>.form-select {\n  padding: 0.365rem 0.75rem;\n  height: 45px;\n  min-height: 45px;\n}\n\n/* END FORM FLOATING */\n\n/* FORM CHECK INPUT */\n.form-check-input {\n  --bs-form-check-bg: var(--bs-body-bg);\n  flex-shrink: 0;\n  width: 1.5em;\n  height: 1.5em;\n  margin-top: 0em;\n  vertical-align: top;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: solid 2px #7f6994;\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n.form-check-input[type=\"checkbox\"] {\n  border-radius: 0.25em;\n}\n\n.form-check-input[type=\"radio\"] {\n  border-radius: 50%;\n}\n\n.form-check-input:active {\n  filter: brightness(90%);\n  border: none;\n}\n\n.form-check-input:focus {\n  border-color: #3d3049;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 109, 253, 0);\n}\n\n.form-check-input:checked {\n  background-color: #7f6994;\n  border-color: #4f3366;\n}\n\n.form-check-input:checked[type=\"checkbox\"] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:checked[type=\"radio\"] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-check-input[type=\"checkbox\"]:indeterminate {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n\n.form-check-input[disabled]~.form-check-label,\n.form-check-input:disabled~.form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n/* END FORM CHECK INPUT */\n\n.profile-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n\n.profile-img {\n  width: 25%;\n  padding: 5px 5px;\n  border: 3px solid #ceae7b;\n  border-radius: 100%;\n}\n\n.profile-verified {\n  width: 1.5rem;\n}\n\n@media (max-width: 575.98px) {\n  .profile-img {\n    width: 50%;\n    padding: 5px 5px;\n    border: 3px solid #ceae7b;\n    border-radius: 100%;\n  }\n\n  .btn-download {\n    width: 50%;\n  }\n}\n\n@media (max-width: 768px) {\n  .btn-download {\n    width: 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
